import React from 'react';
import { Modal, Paper } from '@mui/material';
import EditMissionFlightPathLayout from '../layouts/EditMissionFlightPathLayout';
import {FlightPath} from "../../../classes/FlightPath";
import {Mission} from "../../../classes/Mission";

function NewMissionFlightPathModal(props: {
    isOpen: boolean,
    missionData: Mission,
    onClose: Function,
    onSubmit: Function
}) {

    const newPath = new FlightPath()
    newPath.missionId = props.missionData.id!

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '800px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditMissionFlightPathLayout
                    title="New Flight Path"
                    initData={newPath}
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default NewMissionFlightPathModal;